import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Icon } from 'antd';

import { containerActions } from './actions';
// eslint-disable-next-line
import 'antd/lib/icon/style/css';
import './styles.scss';

const ITEMS = [
  {
    title: 'Our services',
    to: '/',
    id: 1
  },
  {
    title: 'About Us',
    to: '/',
    id: 2
  },
  {
    title: 'Contacts',
    to: '/',
    id: 3
  }
];

const SOCIAL = [
  {
    id: 'fb',
    file: 'ion-social-facebook',
    // file: fb,
    link: '/'
  },
  {
    id: 'gp',
    file: 'ion-social-googleplus',
    // file: gp,
    link: '/'
  },
  {
    id: 'lk',
    file: 'ion-social-linkedin',
    // file: lk,
    link: '/'
  },
  {
    id: 'tw',
    file: 'ion-social-twitter',
    // file: tw,
    link: '/'
  },
  {
    id: 'yt',
    file: 'ion-social-youtube',
    // file: yt,
    link: '/'
  }
];

const Menu = ({ opened }) =>
  opened ? (
    <div className="menu">
      <ul className="menu-items">
        {ITEMS.map(item => (
          <li className="menu-item" key={item.id}>
            <Link to={item.to} className="menu-link">
              {item.title}
            </Link>
          </li>
        ))}
        <li className="menu-item menu-item__border">
          <span className="menu-link">
            <Icon type="environment" size="xs" /> Toronto
          </span>
        </li>
        <li className="menu-item menu-item__border">
          <span className="menu-link">
            <Icon type="global" size="xs" /> English
          </span>
        </li>
      </ul>
      <div className="menu-socials">
        {SOCIAL.map(element => (
          <a href={element.link} key={element.id} className="socials-link">
            <i
              className={`icon -${element.id} ${element.file}`}
            />
          </a>
        ))}
      </div>
    </div>
  ) : null;

Menu.propTypes = {
  opened: PropTypes.bool.isRequired
};

const mapStateToProps = state => ({
  opened: state.menu.opened
});

export default connect(mapStateToProps, containerActions)(Menu);



// WEBPACK FOOTER //
// ./src/components/Menu/index.js